import template from './socialSecurityList.html';
import controller from './socialSecurityList.controller';
import './socialSecurityList.scss';

let socialSecurityListComponent = {
  restrict: 'E',
  bindings: {
    ssData : '<',
  },
  template,
  controller
};

export default socialSecurityListComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurityList/socialSecurityList.component.js